import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass']
})
export class HomeComponent implements OnInit {

  usuario: string;

  constructor() { }

  ngOnInit(): void {
    const user = JSON.parse(localStorage.getItem('user'));
    this.usuario = `${user.userData.nombre} ${user.userData.apellido}`;
  }

}
